const initialState = {
  jobs: [],
};

export const reportJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_REPORT_JOB':
      return {
        ...state,
        jobs: [...state.jobs, action.payload],
      };
    case 'UPDATE_REPORT_JOB':
      return {
        ...state,
        jobs: state.jobs.map((job) =>
          job.id === action.payload.id
            ? { ...job, ...action.payload.updates }
            : job
        ),
      };
    case 'REMOVE_REPORT_JOB':
      return {
        ...state,
        jobs: state.jobs.filter((job) => job.id !== action.payload),
      };
    default:
      return state;
  }
};
